<section class="login-wrap bg-login">
    <div class="container">
        <div class="row align-items-center justify-content-center">
            <!-- Start Signinup Wrap -->
            <div class="col-12 col-sm-10 col-md-7 col-lg-5">
                <div class="signinup-content-wrap overflow-hidden white-bg rounded p-4 p-md-5 ">
                    <div class="signinup-header pb-2">
                        <!-- <div class="logo-box">
                            <img src="assets/images/logo-icon.png" class="logo-login" alt="Login logo">
                        </div> -->
                        <h3 class="title brandsecundary-color primaryfont pt-3"> Delete Your Account  </h3>
                        <!-- <p> Find the most popular Resturent in your area. </p> -->
                    </div>
                    <div class="signinup-form">
                        <form autocomplete="off" [formGroup]="loginData" (ngSubmit)="Onsubmit()">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group pb-3">
                                        <label class="form-label" for="Username"> Email </label>
                                        <input type="email" class="form-control" id="Username" placeholder="lisa@gmail.com" aria-describedby="errorEmail" formControlName="email" [(ngModel)]="email" [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                                        <small id="errorEmail" class="errormessage orange-color d-inline-block pt-2" *ngIf="submitted && f.email.errors"> 
                                                    <div *ngIf="f['email'].errors['required']"> Email is required </div>
                                                    <div *ngIf="f['email'].errors['email']"> Email must be a valid email </div>
                                                </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group pb-3">
                                        <label class="form-label" for="Password">Password</label>
                                        <div class="input-with-ic">
                                            <input type="password" class="form-control" id="password-field" placeholder="***********" minlength="6" [(ngModel)]="password" onkeyup="this.value=this.value.replace(/^\s+/g, '')" formControlName="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                                            <span class="input-icon" (click)="showHide('.toggle-password')"> 
                                            <i class="bx bx-low-vision toggle-password" toggle="#password-field"></i> 
                                        </span>
                                        </div>
                                        <small id="errorEmail" *ngIf="submitted && f.password.errors" class="errormessage orange-color d-inline-block pt-2">
                                                    <div *ngIf="f['password'].errors['required']">Password is required</div>
                                                    <div *ngIf="f['password'].errors['minlength']">Password must be at least 6 characters .</div>
                                                </small>
                                    </div>
                                </div>                              
                                
                                <div class="form-btn-box pt-4 col-12">
                                    <button type="submit" class="btn custom-btn gradient1-btn px-4 w-100">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <!-- <div class="signinup-footer pt-4 text-center">
                                <p> Not a member? <a class="font-w-bold" routerLink="/signup"> Sign Up </a> </p>
                            </div> -->
                </div>
            </div>
            <!-- End Signinup Wrap -->
        </div>
        <!--end row-->

    </div>
</section>
